import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BrokerAuditDeclarationService } from '../../broker-audit-declaration.service';
import { BadSectionModel } from '../../../../model/badSectionModel';
import { BadAnswerModel } from '../../../../model/badAnswerModel';
import { StartFunctionService } from '../../../../shared/utils/start-function.service';
import { WorkflowModel } from '../../../../model/workflowModel';
import { SubmitBrokerAuditQuestionnaireRequestModel } from '../../../../model/submitBrokerAuditQuestionnaireRequestModel';
import { CurrentPageWatcherService } from '../../../../shared/utils/CurrentPageWatcher';
import { MessageModel } from '../../../../model/models';
import { StartFunctionResponseModel } from '../../../../model/startFunctionResponseModel';
import { StorageService } from '../../../../shared/security/StorageService';
import { NgForm, FormArray, FormGroup, FormControl } from '@angular/forms';
import * as $ from 'jquery';
import { Subscription } from 'rxjs';
import { BrokerAuditDeclarationSaveDataService } from '../../broker-audit-declaration-save-data.service';

@Component({
  selector: 'app-bad-questionnaire-section',
  templateUrl: './bad-questionnaire-section.component.html',
  styleUrls: ['./bad-questionnaire-section.component.css']
})
export class BadQuestionnaireSectionComponent implements OnInit, OnDestroy {
  
  badSectionModel : BadSectionModel;
  sectionIndex : number;
  workflow: WorkflowModel = new WorkflowModel();
  submitBrokerAuditQuestionnaireRequestModel : SubmitBrokerAuditQuestionnaireRequestModel = new SubmitBrokerAuditQuestionnaireRequestModel();

  additionalComments : boolean = false;
  urlParam : number;
  startFunction: StartFunctionResponseModel;
  
  userMessages: Array<MessageModel> = [];
  form: FormGroup ;

  explanations : Array<string>=[];

  SaveDataSubscription : Subscription = new Subscription();

  constructor(private route : ActivatedRoute,
    private router : Router,
    private brokerAuditDeclarationService: BrokerAuditDeclarationService,
    private startFunctionService : StartFunctionService,
    private currentPageWatcher : CurrentPageWatcherService,
    private storageService : StorageService,
    private brokerAuditDeclarationSaveDataService : BrokerAuditDeclarationSaveDataService) 
    {

       //save current values
    this.SaveDataSubscription =this.brokerAuditDeclarationService.getNotifySaveData().subscribe((data:Boolean)=>{
      if(data == true){
        if (this.form.valid) {
          this.brokerAuditDeclarationSaveDataService.submitBADQuestionnaire();
        }
        else {
          this.handleBadQuestionnaireFormErrors();
        }
      }
    })
     }

  ngOnInit() {
    this.startFunction = this.storageService.getStartFunctionData();

    this.workflow = this.brokerAuditDeclarationService.brokerAuditDeclarationWorkflowModel;
//get actual section by url param (param = sectionId)
    this.route.params.subscribe(params => {
      this.urlParam = params.id;
      this.brokerAuditDeclarationService.badQuestionnaireDataModel.Sections.forEach(section => {
        if (section.SectionID == params.id) {
          //get section index from brokerADQuestionnaireSectionsList
          this.sectionIndex = this.brokerAuditDeclarationService.brokerADQuestionnaireSectionsList.indexOf(section.SectionID);
          
          section.Questions.forEach(question=>{
           // find answer by QuestionID from this.brokerAuditDeclarationService.badQuestionnaireDataModel.Answers
            if(this.brokerAuditDeclarationService.badQuestionnaireDataModel.Answers.filter(a=>a.QuestionID==question.QuestionID)==undefined || this.brokerAuditDeclarationService.badQuestionnaireDataModel.Answers.filter(a=>a.QuestionID==question.QuestionID).length==0){
              question.Answer= new BadAnswerModel();
              question.Answer.AnswerTypeID = null;
            }
            else{
              //add found answer in badQuestionnaireDataModel by QuestionID 
              question.Answer = this.brokerAuditDeclarationService.badQuestionnaireDataModel.Answers.filter(a=>a.QuestionID==question.QuestionID)[0];
             }
          }
         
           )
          this.badSectionModel = section;

          //explanation array
          this.badSectionModel.Questions.forEach(question=>{
            this.explanations.push("explanation"+question.QuestionID)
          });

          //build form
          //first : questions
          let group : any = {};
          this.badSectionModel.Questions.forEach(question=>{
            group[question.QuestionID]=new FormControl('');
          });
          //create form with group
          this.form = new FormGroup(group);

          //second: explanation (dynamic control)
          this.badSectionModel.Questions.forEach(question => {
            this.form.get(question.QuestionID.toString()).valueChanges.subscribe(val => {
              if ((question.YesExplanationRequired && val == 1) || (question.NoExplanationRequired && val == 2) || (question.NAExplanationRequired && val == 3)) {
                this.form.addControl(this.explanations[this.badSectionModel.Questions.indexOf(question)], new FormControl(''))
              }
              else{
                if(this.form.get(this.explanations[this.badSectionModel.Questions.indexOf(question)])){
                  this.form.removeControl(this.explanations[this.badSectionModel.Questions.indexOf(question)]);
                }
              }
              console.log("======>", this.form);
            });
          });
          
        }
      });
    });
  }

  continue() {
    console.log("=========> ",this.form);

    this.currentPageWatcher.clearUserMessage();
    if (this.form.valid) {
      this.badSectionModel.Questions.forEach(quest => {
        //fill badQuestionnaireDataModel answers 
        quest.Answer.QuestionID = quest.QuestionID;
        if (this.brokerAuditDeclarationService.badQuestionnaireDataModel.Answers.filter(answ => answ.QuestionID == quest.Answer.QuestionID).length == 0) {
          this.brokerAuditDeclarationService.badQuestionnaireDataModel.Answers.push(quest.Answer);
        }
        else {
          this.brokerAuditDeclarationService.badQuestionnaireDataModel.Answers.filter(answ => answ.QuestionID == quest.Answer.QuestionID)[0] = quest.Answer;
        }
      });

      //increment section list
      let nextSectionId = this.brokerAuditDeclarationService.brokerADQuestionnaireSectionsList[this.sectionIndex + 1];
      //if no more questionnaire declaration section
      if (nextSectionId == null || nextSectionId == undefined) {
        this.router.navigate(['/questionnaireAuditDeclarationComment']);
      }
      //if more questionnaire declaration section
      else {
        //save questionnaire as a draft
        //this.submitBADQuestionnaire(nextSectionId);
        this.router.navigate(['/questionnaireAuditDeclarationSection', nextSectionId]);

      }
    }

    else{
      this.handleBadQuestionnaireFormErrors();
    }

  }

  handleBadQuestionnaireFormErrors(){

    let explanationError = false;
    let questionError =false;

    let questionsErrorMessage: MessageModel = {};
    questionsErrorMessage.Alert = 3;
    questionsErrorMessage.Description = "You must answer all questions.";

    let explanationErrorMessage: MessageModel = {};
    explanationErrorMessage.Alert = 3;
    explanationErrorMessage.Description = "Explanation is required.";

    this.explanations.forEach(explanation=>{
      if(this.form.get(explanation) !=undefined && this.form.get(explanation).errors !=null && this.form.get(explanation).errors.required){
        explanationError = true;
    }
    })
    
    this.badSectionModel.Questions.forEach(quest=>{
      if(this.form.get(quest.QuestionID.toString()) !=undefined && this.form.get(quest.QuestionID.toString()).errors !=null && this.form.get(quest.QuestionID.toString()).errors.required){
        questionError= true;
    }
    })
   
    if(explanationError){
      this.userMessages.push(explanationErrorMessage);
    }

    if(questionError){
      this.userMessages.push(questionsErrorMessage);
    }

    this.currentPageWatcher.sendUserMessages(this.userMessages);
    $("html, body").animate({ scrollTop: 0 }, "slow");
    this.userMessages = [];
  }

  goBack() {
    this.currentPageWatcher.clearUserMessage();
    //if first section, then navigate to enter data sections
    if (this.sectionIndex == 0) {
      //decrement workflow step
      this.startFunctionService.getNotifyStepInProgress().emit(false);
      //navigate to data + false
      this.navigateToBrokerAuditDeclarationData();

    }
    else {
        //decrement section list
        let lastSectionId = this.brokerAuditDeclarationService.brokerADQuestionnaireSectionsList[this.sectionIndex - 1]
        this.router.navigate(['/questionnaireAuditDeclarationSection', lastSectionId]);
    }

  }
  navigateToBrokerAuditDeclarationData(){

    // this.brokerAuditDeclarationService.brokerAuditDeclarationWorkflowModel.CurrentStepIndex = this.workflow.CurrentStepIndex - 1;

    //find last section = first section in the list with value less than 9 (actual section)
    let lastSection = Math.max.apply(Math, this.brokerAuditDeclarationService.brokerDataDeclarationSectionList.filter(function(x){return x < 9}));
    console.log("lastSection : ",lastSection);
  
    switch (lastSection) {
          
      case 1: {
        this.router.navigate(['/section1BaData']);
        break;
      }
      case 2: {
        this.router.navigate(['/section2BaData']);
  
        break;
      }
      case 3: {
       this.router.navigate(['/section3BaData']);
  
       break;
     }
     case 4: {
      this.router.navigate(['/section4BaData']);
  
      break;
    }
    case 5: {
      this.router.navigate(['/section5BaData']);
  
      break;
    }
  
    case 6: {
      this.router.navigate(['/section6BaData']);
  
      break;
    }
    case 7: {
      this.router.navigate(['/section7BaData']);
  
      break;
    }

    case 8: {
      this.router.navigate(['/section8BaData']);
  
      break;
    }
    case 9:{
      this.router.navigate(['/section9BaData']);
  
      break;
    }
      default: {
        //brokerageInformation
        this.router.navigate(['/brokerageInformation']);
  
        break;
      }
    }
  }

  ngOnDestroy(): void {
    if(this.currentPageWatcher.displayUserMessage == false){
      this.currentPageWatcher.clearUserMessage();
    }

    this.SaveDataSubscription.unsubscribe();
  }

   //back browser button
   @HostListener('window:popstate', ['$event'])
   onPopState(event) {
      this.goBack();

   }
}



// WEBPACK FOOTER //
// ./src/app/broker/broker-audit-declaration/questionnaire-broker-audit-declaration/bad-questionnaire-section/bad-questionnaire-section.component.ts